/**
 * @generated SignedSource<<53ecf23e8f3a7993de25e373b987f8fe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type finishQuery$variables = {
  pickupId: string;
};
export type finishQuery$data = {
  readonly pickup: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly name: string;
        readonly organization: {
          readonly id: string;
          readonly slug: string;
        };
      } | null | undefined;
    };
    readonly id: string;
  };
};
export type finishQuery = {
  response: finishQuery$data;
  variables: finishQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pickupId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pickupId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HubMeta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "finishQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "Pickup",
          "kind": "LinkedField",
          "name": "pickup",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v3/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "finishQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Pickup",
        "kind": "LinkedField",
        "name": "pickup",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84be5acc4429d75dc3ecd2beeaf76032",
    "id": null,
    "metadata": {},
    "name": "finishQuery",
    "operationKind": "query",
    "text": "query finishQuery(\n  $pickupId: UUID!\n) {\n  pickup(id: $pickupId) {\n    id\n    hub {\n      id\n      meta {\n        id\n        name\n        organization {\n          id\n          slug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf278e7ad1d6b40c88098a0803365370";

export default node;
